<template>
    <div>
        <div v-show="!isLoadingAddresses && !isLoadingShippingAddress">
            <div class="alert alert-danger" v-if="hasForbiddenProduct">
                <strong>Nous vous informons que...</strong><br/>
                <ul><li v-for="p in forbiddenCountriesProduct">{{ p }} n'est pas disponible à la vente dans votre pays.</li></ul>
                Vous pouvez retourner dans <a href="/panier">votre panier</a> pour modifier votre commande.
            </div>

            <div class="blockAddresses">
                <h2>Mes adresses</h2>
                <ponroy-order-shipping-address :address="shippingAddress" v-cloak>
                    <slot slot="shippingAddressForm" name="shippingAddressForm"/>
                    <slot slot="shippingAddressModalForm" name="shippingAddressModalForm"></slot>
                </ponroy-order-shipping-address>

                <ponroy-order-billing-address :address="billingAddress" v-cloak>
                    <slot slot="billingAddressForm" name="billingAddressForm"/>
                    <slot slot="billingAddressModalForm" name="billingAddressModalForm"></slot>
                </ponroy-order-billing-address>
            </div>
        </div>

        <div class="loader" v-show="isLoadingAddresses || isLoadingShippingAddress">
            <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>

    </div>

</template>

<script>

    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';

    const OrderDelivery = {
        name: 'ponroy-order-delivery',
        store,
        props: {
            forbiddenCountriesItems: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                forbiddenCountriesProduct: [],
            };
        },
        computed: {
            ...mapGetters('order', ['shippingAddress', 'billingAddress', 'isLoadingAddresses', 'isLoadingShippingAddress', 'hasForbiddenProduct']),
        },
        methods: {
            hasForbiddenCountries() {

                let flag = false;
                this.forbiddenCountriesProduct = [];
                this.$store.commit('order/SET_HAS_FORBIDDEN_PRODUCT', false);

                if (null !== this.shippingAddress) {

                    for (let k in this.forbiddenCountriesItems) {
                        let forbiddenCountryProduct = this.forbiddenCountriesItems[k].productReference.product;
                        let forbiddenCountries = forbiddenCountryProduct.forbiddenCountries.map(el => el.id);

                        if (forbiddenCountries.includes(this.shippingAddress.country.id)) {
                            this.forbiddenCountriesProduct.push(forbiddenCountryProduct.title);
                            flag = true;
                        }
                    }
                }

                if (true === flag) {
                    this.$store.commit('order/SET_HAS_FORBIDDEN_PRODUCT', true);
                    return true;
                }

                return false;
            },
        },
        watch: {
            shippingAddress() {
                this.hasForbiddenCountries();
            }
        }
    };

    export default OrderDelivery;
</script>

<style>
    .loader {
        text-align: center;
        margin-top: 20px;
        color: grey;
    }
</style>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderDelivery.vue